import { Component, OnInit } from '@angular/core';
import { PlanType } from 'src/app/core/enums/user';
import { SignUpModel } from 'src/app/core/models/user';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { Role } from 'src/app/core/models/user-management/role';
import { AlertDialogModel } from '../../../core/models/view-model/alert-dialog.model';
import { FileUploadDialogComponent } from '../file-upload-dialog/file-upload-dialog.component';
import { UserLicensedModel } from './../../../core/models/user-management/user-licensed-model';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { MatDialog } from '@angular/material/dialog';
import { Jurisdiction } from 'src/app/core/models/user/jurisdiction';
import { JurisdictionsList, jurisdictionType } from 'src/app/core/models/impact-assessment/jurisdictions-list-model';

@Component({
  selector: 'app-create-users',
  templateUrl: './create-users.component.html',
  styleUrls: ['./create-users.component.scss']
})
export class CreateUsersComponent implements OnInit {
  registerForm: any;
  submitted = false;
  isLoading = false;
  isLoadingLicensed = false;
  isDisabled = false;
  showMsg = false;
  isEmailError = false;
  isUserId = false;
  selectedRole: number;
  userRoleList: Array<Role>;
  isLoader = false;
  alertDialogModel: AlertDialogModel;
  toastModel: ToastViewModel;
  isToastShow = false;
  licensedData: UserLicensedModel;
  isShowMessage = false;
  //alphaNumericValidPattern = "/^(?:[a-zA-Z0-9\s]+)?$/";

  constructor(private userManagementService: UserManagementService, private formBuilder: FormBuilder, public dialog: MatDialog) {
    this.selectedRole = 0;
    this.userRoleList = [];
    this.alertDialogModel = new AlertDialogModel();
    this.toastModel = new ToastViewModel();
    this.licensedData = new UserLicensedModel();
  }

  ngOnInit(): void {
    this.fetchLicensedDetails();
    this.fetchUserRoleList();
    this.fetchJurisdictions();
    this.registerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailId: ['', Validators.required],
      role: [0, Validators.required],
      mobile: [''],
      // userId: ['',[Validators.required, Validators.pattern(this.alphaNumericValidPattern)]]
      UserIdByUser: ['', [Validators.required]],
      SelectedJurisdictionList: [[], [Validators.required]]
    });

  }
  get formField(): any { return this.registerForm.controls; }

  fetchLicensedDetails(): void {
    this.userManagementService.getLicensedDetails().subscribe((result: UserLicensedModel) => {
      this.licensedData = result;
    });
  }

  fetchUserRoleList(): void {
    this.isLoadingLicensed = true;
    this.userManagementService.getRoles().subscribe((userRole: Role[]) => {
      this.userRoleList = userRole;
      if (userRole && userRole.length > 0) {
        this.selectedRole = userRole[0].id;
      }
      this.isLoadingLicensed = false;
    });
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.licensedData && this.licensedData.unUsedLicensed === 0) {
      this.isShowMessage = true;
      setTimeout(() => {
        this.isShowMessage = false;
      }, 4000);
      return;
    }
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    } else {
      this.isLoader = true;
      this.isDisabled = true;
      const signupModel = this.registerForm.value as SignUpModel;
      signupModel.PlanType = PlanType.Trial;
      signupModel.AccountName = 'TrialAccount';
      this.userManagementService.registerUser(this.registerForm.value).subscribe(() => {
        this.showMsg = true;
        this.isDisabled = false;
        this.isLoader = false;
        setTimeout(() => {
          this.showMsg = false;
        }, 4000);
      }, (result) => {
        this.isDisabled = false;
        this.isLoader = false;
        if (result.error.match('User Id Already Exist')) {
          this.isUserId = true;
        }
        else if (!result.error.match('The specified password does not comply with password complexity requirements')) {
          this.isEmailError = true;
        }
        setTimeout(() => {
          this.isEmailError = false;
          this.isUserId = false;
        }, 7000);
      });
    }
  }

  downloadUserTemplate(): void {
    this.isLoading = true;
    this.userManagementService.downloadUserTemplate()
      .subscribe((data: any) => {
        this.isLoading = false;
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `BulkUserImportTemplate.xlsx`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      });
  }

  openDialog(): void {
    this.alertDialogModel.HeadingText = 'Upload Bulk Users';
    this.alertDialogModel.BodyText = '';
    this.alertDialogModel.ActionButtonText = 'Upload';
    this.alertDialogModel.IsAction = true;
    const dialogRef = this.dialog.open(FileUploadDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.uploadFileToActivity(result);
      }
    });
  }

  uploadFileToActivity(fileToUpload: File): void {
    this.isLoading = true;
    this.userManagementService.postFile(fileToUpload).subscribe((result: any) => {
      this.isLoading = false;
      if (result.data) {
        this.alertMessage('success', 'Users uploaded successfully');
      } else {
        this.alertMessage('warning', 'Some users were not imported due to errors in data provided');
       //this.alertMessage('warning', 'Users not uploaded, please check your data');
      }
    }, (err: HttpErrorResponse) => {
      this.isLoading = false;
      this.alertMessage('warning', 'Users not uploaded, please check your data');
    });
  }

  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 4000);
  }
  keyPressAlphaNumeric(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  jurisdictionList: Array<jurisdictionType> = [];
  //selectedJurisdictionList = new FormControl([]);
  fetchJurisdictions(): void {
    this.userManagementService.GetJurisdictionsList().subscribe((data: JurisdictionsList) => {
      this.jurisdictionList = data.jurisdictions;
    });
  }
 
  // Function to remove a jurisdiction chip
  removeJurisdiction(id: number): void {
    const currentSelections = this.registerForm.get('SelectedJurisdictionList').value;
    const filteredSelections = currentSelections.filter((jurisdictionId: number) => jurisdictionId !== id);
    this.registerForm.get('SelectedJurisdictionList').setValue(filteredSelections);
  }
  getJurisdictionTitle(id: number): string {
    const jurisdiction = this.jurisdictionList.find(option => option.id === id);
    return jurisdiction ? jurisdiction.title : '';
  }
}
